import { useSubdomainInfo } from 'shared/Site/api'
import { SiteType } from 'shared/Site/siteType'

export const useIsLuckyBirdGlobalAuth = () => {
  const { data: subdomainInfo } = useSubdomainInfo()

  return subdomainInfo?.data?.type === SiteType.luckyBirdGlobal
}
